module.exports = __webpack_public_path__ + "img/harish-pro.ec56497a.jpg";